module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point01-1-d2ed8f2e5b3604fe55b2723248998a8e.jpg";